<template>
  <div class="readonly__container text-muted">
    <div class="readonly__container__data-section">
      <SectionTitle content="Detonante"/>
      <div>{{ value.trigger }}</div>
    </div>

    <div class="readonly__container__data-section">
      <SectionTitle content="Ambiente"/>
      <div>{{ value.environment }}</div>
    </div>

    <div class="readonly__container__data-section">
      <SectionTitle content="Función del comportamiento"/>
      <ul>
        <li v-for="item in value.behavioralFunctions">
          <span v-if="item.id == behavioralFunctionOtherId">
            {{value.behavioralFunctionOtherText}}
          </span>
          <span v-else>{{item.name}}</span>
        </li>
      </ul>
    </div>

    <div class="readonly__container__data-section">
      <SectionTitle content="Plan Conductual"/>
      <div>{{ value.behavioralPlan.name }} - Requiere plan conductal</div>
      <div
        class="readonly__container__data-section__file-input"
        v-if="value.behavioralPlan.id == behavioralPlanYes"
      >
        <CustomFileInput
          display-style="normal"
          :disabled="true"
          :on-download="downloadFile"
          :attachment-id="value.behavioralPlanFileId"
          :name="value.behavioralPlanFileName"
        />
      </div>
    </div>

    <div class="readonly__container__data-section">
      <SectionTitle content="Estrategias"/>
      <IndexableGroup
        title="Estrategia"
        v-model="value.strategies"
        :disabled="true"
      />
    </div>

    <div class="readonly__container__data-section">
      <SectionTitle content="Colaboración Familiar"/>
      <IndexableGroup
        title="Colaboración Familiar"
        v-model="value.familyCollaborations"
        disabled
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
import CustomFileInput from "CustomFileInput";
import _generalService from "@/services/pei/general";
import IndexableGroup from "./../Indexable/IndexableGroup.vue";
import { GetDefaultInappropriateBehavior } from './Form.vue';

const BehavioralPlanYes = 1;
const BehavioralFunctionOtherId = 5;

export default {
  name: 'InappropriateBehaviorReadonly',
  components: {
    SectionTitle,
    IndexableGroup,
    CustomFileInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => (GetDefaultInappropriateBehavior()),
    },
    isOpen: false
  },
  data() {
    return {
      behavioralPlanYes: BehavioralPlanYes,
      behavioralFunctionOtherId: BehavioralFunctionOtherId,
    };
  },
  methods: {
    async downloadFile(uid) {
      if (!uid) return;
      _generalService.downloadDocumentByAttachmentId(uid);
      this.$emit("download-file", uid);
    },
  },
};
</script>

<style scoped>
.readonly__container {
  padding: 20px;
}

.readonly__container__data-section {
  margin: 20px 0;
  padding-bottom: 40px;
  border-bottom: 1px solid #c6cdcf;
}

.readonly__container__data-section__file-input {
  padding: 20px;
  display: flex;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 20px;
  justify-content: center;
  background-color: #fafbfa;
  border: 1px solid #c6cdcf;
}
</style>
